module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"event":{"button":"Alle Events ansehen","description":"Nehmen Sie an spannenden Events teil und erweitern Sie Ihr Netzwerk","title":"Anstehendes Event"}}}}}}')
  delete Component.options._Ctor
}
